import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-collapse-panel',
  templateUrl: './error-collapse-panel.component.html',
  styleUrls: ['./error-collapse-panel.component.less']
})
export class ErrorCollapsePanelComponent {
  @Input() errorMessageList : Array<string> = [];
  @Input() errorHeaderTitle : string = 'Errors';
  errorMessagePanel = {
    active: false,
    name: 'Errors',
    arrow: true
  }
  constructor() { }

}
